<div class="intro-box">
  <div class="row">
    <div class="columns small-12 medium-10 medium-offset-1">
      <div class="intro-content">
        AlphaFold DB provides open access to over 260 million protein structure predictions to accelerate scientific research.
      </div>
    </div>
  </div>
</div>

<section>
  <div class="row info-section first-section">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h3>Background</h3>
      <div class="row">

        <div class="columns medium-6 info-content">
          <p class="large-text">
            <a (click)="gaService.eventEmitter(
            'link_visit',
            'home_href_click',
            'click',
            'dm_blog',
            '')" href="https://deepmind.com/blog/article/putting-the-power-of-alphafold-into-the-worlds-hands"
              target="_blank">AlphaFold</a>
            is an AI system developed by <a (click)="gaService.eventEmitter(
            'link_visit',
            'home_href_click',
            'click',
            'deepmind',
            '')" href="https://deepmind.google/" target="_blank">Google DeepMind</a>
            that predicts a protein’s 3D structure from its amino acid
            sequence. It regularly achieves accuracy competitive with experiment.
          </p>

          <p class="normal-text">
            Google DeepMind and EMBL’s European Bioinformatics Institute
            (<a href="http://www.ebi.ac.uk" target="_blank">EMBL-EBI</a>) have partnered to create AlphaFold DB
            to make these predictions freely available to the scientific community. The latest database release contains
            over 200 million entries,
            providing broad coverage of <a href="https://www.uniprot.org/uniprotkb" target="_blank">UniProt</a> (the
            standard repository of protein sequences and annotations). We provide individual
            <a [routerLink]="['/download']">downloads</a> for the human proteome and for the proteomes of 47 other key
            organisms important in research and global health.
            We also provide a download for the manually curated subset of UniProt (<a
              href="https://www.expasy.org/resources/uniprotkb-swiss-prot" target="_blank">Swiss-Prot</a>).
          </p>
        </div>

        <div class="columns medium-6 info-content" style="text-align: center;">
          <img class="ex-img" ngSrc="assets/img/Q8I3H7_1.webp" width="600" height="400" alt="image1" loading="lazy">
          <p class="img-caption">Q8I3H7: May protect the malaria parasite against attack by the immune system. Mean
            pLDDT 85.57.</p>
          <p class="img-caption"><a [routerLink]="['entry','Q8I3H7']" class="img-caption">View protein</a></p>
        </div>

      </div>

      <div class="row info-section-row-2">

        <div class="columns medium-6 medium-push-6 info-content">
          <p class="large-text" style="margin-bottom:30px;">
            In <a (click)="gaService.eventEmitter('link_visit', 'home_href_click', 'click','casp14', '')"
              href="https://predictioncenter.org/casp14/zscores_final.cgi" target="_blank">CASP14</a>,
            AlphaFold was the top-ranked protein structure prediction method by a large margin, producing
            predictions with <a
              (click)="gaService.eventEmitter('link_visit', 'home_href_click', 'click', 'faq_accuracy', '')"
              [routerLink]="['faq']" fragment="faq-3">high accuracy</a>. While the system still has some
            <a (click)="gaService.eventEmitter('link_visit', 'home_href_click', 'click', 'faq_limitations', '')"
              [routerLink]="['faq']" fragment="faq-6">limitations</a>,
            the CASP results suggest AlphaFold
            has immediate potential to help us understand the structure of proteins and advance biological research.
          </p>
          <p class="normal-text">Let us know how the AlphaFold Protein Structure Database has been useful in your
            research, or if
            you have questions not answered in the <a [routerLink]="['faq']">FAQs,</a> at
            <a class="licenseLink" href="mailto:alphafold@deepmind.com">alphafold&#64;deepmind.com</a>.
          </p>
          <p class="normal-text">
            If your use case isn't covered by the database, you can generate your own AlphaFold predictions using this
            <a (click)="gaService.eventEmitter(
              'link_visit',
              'home_href_click',
              'click',
              'source_code',
              '')" href="https://github.com/deepmind/alphafold/" target="_blank">open source code</a>, which also
            supports multimer prediction.
          </p>
        </div>

        <div class="columns medium-6 medium-pull-6 info-content" style="text-align: center;">

          <img class="ex-img" ngSrc="assets/img/Q8W3K0.webp" width="600" height="400" alt="image2" loading="lazy">
          <p class="img-caption">Q8W3K0: A potential plant disease resistance protein. Mean pLDDT 82.24.</p>
          <p class="img-caption"><a [routerLink]="['entry','Q8W3K0']" class="img-caption">View protein</a></p>
        </div>

      </div>

    </div>
  </div>
</section>


<div class="find-more-box">
  <div class="row">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h3>Find out more</h3>
      <div class="row news-row">
        <app-home-links [findOutMore]="findOutMore"></app-home-links>
        <div class="columns medium-6">
        </div>
      </div>
    </div>
  </div>
</div>

<section>
  <div id="news" class="row info-section">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h3>What’s new?</h3>
      <div class="row">

        <div class="columns medium-6 medium-push-6 info-content">
          <p class="large-text" style="margin-bottom:30px;">
            AI-derived residue annotations – October 2026
          </p>
          <p class="normal-text">
           AlphaFold Database now integrates AI-derived residue-level annotations from the scientific literature, providing biological context for individual residues alongside predicted protein structures. A transformer-based named entity recognition (NER) model identifies protein residues and point mutations in structural biology publications and links experimentally supported annotations to UniProt reference sequences.
          </p>
          <p class="normal-text">Annotations are transferred from experimentally validated PDB structures to AlphaFold models using the SIFTS framework, ensuring that literature-derived residue annotations are supported by experimental evidence.</p>
          <p class="normal-text">
          This release enables users to navigate directly from residues in AlphaFold predictions to publications describing their function, interactions, and experimentally observed mutations, making it easier to interpret predicted structures in their biological context.
          </p>
          
         
          
          <!-- <p class="ourlink"><a href="/latest" target="_blank" (click)="gaService.eventEmitter(
            'latest_link_visit',
            'Whats_new',
            'click',
            'Browse_latest_dataset',  
            'Click on link for all the latest dataset')">Browse all VAD structures <img src="/assets/img/Link.svg" alt="Link icon" width="16" height="16"></a>
          </p> -->
          <!-- [To do] : need to uncomment the below paragraph when link will be live -->
          
            <p class="ourlink"><a href="https://pubmed.ncbi.nlm.nih.gov/39333508/" target="_blank" (click)="gaService.eventEmitter(
            'social_link_visit',
            'Whats_new',
            'click',
            'ai_annoattions_link',  
            'Click on link to whats new section')">Read more about text-mined residue and point mutation <span style="white-space: nowrap;">annotations <img src="/assets/img/Link.svg" alt="Link icon" width="16" height="16" class="ourlink-icon"></span></a>
          </p>

          <!-- <p class="ourlink"><a href="/faq#faq-40" target="_blank" (click)="gaService.eventEmitter(
            'social_link_visit',
            'Whats_new',
            'click',
            'VAD_link',
            'Click on link to social media news item')">Read more about VAD  <img src="/assets/img/Link.svg" alt="Link icon" width="16" height="16" class="ourlink-icon"></a></p> -->

            <!-- <p class="ourlink"><a href="https://www.embl.org/news/science-technology/alphafold-database-adds-viral-protein-complexes-to-support-pandemic-preparedness/" target="_blank" (click)="gaService.eventEmitter(
            'social_link_visit',
            'Whats_new',
            'click',
            'Item_EBI_link',  
            'Click on link to social media news item')">Read full article on EMBL-EBI site <img src="/assets/img/Link.svg" alt="Link icon" width="16" height="16" class="ourlink-icon"></a></p> -->
        </div>

        <div class="columns medium-6 medium-pull-6 info-content" style="text-align: center;">
          
          <img class="news-img" 
          ngSrc="assets/img/AI-annotations-release.webp" 
          width="600"
          height="400"
          alt="news image">
          <br/>
          <br/>
          <p class="img-caption"><a (click)="gaService.eventEmitter(
            'example_link_visit',
            'Whats_new',
            'click',
            'Viral_protein_example',
            'Click on link to see the example [View protein]')" href="/faq#faq-45" target="_blank" class="img-caption">Learn how residue function annotations are generated and mapped to AlphaFold structures</a></p>
        </div>

      </div>
    </div>
  </div>
</section>

<section>
  <div class="row info-section">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h3>What’s next?</h3>
      <p class="large-text" style="margin-bottom: 0;">
        We plan to continue updating the database with structures for newly discovered protein sequences, and to improve
        features and functionality in response to user feedback.
        Please follow <a (click)="gaService.eventEmitter(
      'link_visit',
      'home_href_click',
      'click',
      'deepmind_social',
      '')" href="https://twitter.com/GoogleDeepMind" target="_blank">Google DeepMind</a>'s and
        <a (click)="gaService.eventEmitter(
      'link_visit',
      'home_href_click',
      'click',
      'embl_social',
      '')" href="https://twitter.com/emblebi" target="_blank">EMBL-EBI</a>’s social channels for updates.
      </p>
    </div>
  </div>
</section>

<section>
  <div class="row info-section more-spacing">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h3>Licence and attributions</h3>
      <p class="large-text" style="margin-bottom: 0;">Data is available for academic and commercial use, under a <a
          (click)="gaService.eventEmitter(
        'link_visit',
        'home_href_click',
        'click',
        'license',
        '')" href="https://creativecommons.org/licenses/by/4.0/" target="_blank">CC-BY-4.0</a> licence. </p>
      <p class="small-text" style="margin-bottom: 0; margin-top: 20px;"> EMBL-EBI expects attribution (e.g., in
        publications, services, or products) for any of its online services, databases, or software in accordance with
        good scientific practice.</p>
      <p class="small-text small-text-bold" style="margin-bottom: 0; margin-top: 20px;">
        If you use this resource, please cite the following papers:
      </p>
      <p class="small-text" style="margin-bottom: 0; margin-top: 2px;"><a
          href="https://academic.oup.com/nar/article/54/D1/D358/8340156" target="_blank">
          Bertoni D. <i>et al.</i> AlphaFold Protein Structure Database 2025: a redesigned interface and updated structural coverage, Nucleic Acids Research, (2025)
        </a></p>
      <p class="small-text" style="margin-bottom: 0; margin-top: 2px;">Note: A given structure may be associated with
        further publications. For authoritative information regarding the relevant publication(s), please consult the
        dataset collection or the structure metadata provided on the entry page.</p>

      <p class="small-text small-text-bold" style="margin-bottom: 0; margin-top: 20px;">
        If you use data from AlphaMissense in your work, please cite the following paper:

      </p>
      <p class="small-text" style="margin-bottom: 0; margin-top: 2px;"> <a
          href="https://www.science.org/doi/10.1126/science.adg7492" target="_blank">Cheng, J <i>et al.</i> Accurate
          proteome-wide missense variant effect prediction with AlphaMissense. Science (2023).
        </a></p>

      <p class="small-text small-text-bold" style="margin-bottom: 0; margin-top: 20px;">
        AlphaFold Data Provided by GDM:
      </p>
      <p class="small-text" style="margin-bottom: 0; margin-top: 2px;">
        AlphaFold Data Copyright (2022) DeepMind Technologies Limited.
      </p>
      <p class="small-text small-text-bold" style="margin-bottom: 0; margin-top: 20px;">
        For AlphaFold Data provided by third party data providers:
      </p>
     
      <div class="small-text" style="margin-bottom: 0; margin-top: 20px;">
        <ul>
          <li>
            Kinetoplastid data copyright (2025) Wheeler Lab <br /> <a target="_blank"
              href="https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0259871">Wheeler RJ. A resource for
              improved predictions of Trypanosoma and Leishmania protein three-dimensional structure. PLoS One (2021)</a>
          </li>
          <li>
            AllTheBacteria data copyright (2025) AllTheBacteria Consortium <br /> <a
              href="https://www.biorxiv.org/content/10.1101/2024.03.08.584059v7" target="_blank">Hunt M, Lima L, Anderson
              D, Bouras G, Hall M, Hawkey J, Schwengers O, Shen W, Lees JA, Zamin Iqbal Z. BioRXiV (2025)</a>
          </li>
          <li>
            A BFVD Data Copyright (2025) The BFVD Development Team <br /> <a
              href="https://academic.oup.com/nar/article/53/D1/D340/7906834" target="_blank">Kim, RS et al. BFVD—a large
              repository of predicted viral protein structures. NAR (2024)</a>
          </li>
          <li>
            Viro3D dataset (2025)
            <br /> <a href="https://link.springer.com/article/10.1038/s44320-025-00147-9" target="_blank">Litvin, U et al. Viro3D: a comprehensive database of virus protein structure predictions. Mol Syst Biol (2025) </a>
          </li>
          <li>
          VAD dataset (2026) <br/>
           <a href="https://www.science.org/doi/10.1126/sciadv.adz8560" target="_blank"> Odai, R., Leemann, M., Al-Murad, T., Abdullah, M., Shyrokova, L., Tenson, T., Hauryliuk, V., Durairaj, J., Pereira, J., Atkinson, G.C. The Viral AlphaFold Database of monomers and homodimers reveals conserved protein folds in viruses of bacteria, archaea, and eukaryotes. Science Advances (2025)  </a>
        </li>
        </ul>
      </div>
      <p class="small-text" style="margin-bottom: 0;">
        AlphaMissense Copyright (2023) DeepMind Technologies Limited.
      </p>
    </div>
  </div>
</section>


<section>
  <div class="row info-section">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h3>FAQs</h3>
      <app-faqs-list [count]="1" [idsFilter]="['faq-35', 'faq-9', 'faq-14', 'faq-19']" ngSkipHydration></app-faqs-list>
      <p class="faq-link">
        <a [routerLink]="['faq']">View all frequently asked questions</a>
      </p>
    </div>
  </div>
</section>

<section>
  <div class="row info-section">
    <div class="columns small-12 medium-10 medium-offset-1">
      <h3>EMBL-EBI training</h3>
      <app-training-courses></app-training-courses>
    </div>
  </div>
</section>